import { render, staticRenderFns } from "./TabsWhatsApp.vue?vue&type=template&id=114d63d7&scoped=true"
import script from "./TabsWhatsApp.vue?vue&type=script&lang=js"
export * from "./TabsWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./TabsWhatsApp.vue?vue&type=style&index=0&id=114d63d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114d63d7",
  null
  
)

export default component.exports